/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useState, useRef, Fragment, useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { generatePath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WithMoviesWatchlistBtn, ButtonWatchlist } from "app/modules/watchlist";
import { sessionsReducer } from "app/utils";
import {
  useUtils,
  useConfig,
  useDateSelector,
  useDateUrlReplace,
  useUrlParams,
  useRouter
} from "app/hooks";
import {
  NavTabs,
  Container,
  MoviesDatesFilter,
  TitleWithPoster,
  SessionState,
  CinemaInfo,
  TicketsList,
  NoContent
} from "app/components";
import { EntityGallery, MainEntityDetails } from "app/components/Entity";
import FavoriteBtn from "../FavoriteBtn";
import CinemaMap from "./components/CinemaMap";
import Aside from "./components/Aside";
import { SessionsList, SessionsListItem } from "./components/styles";
import SectionCinemaDetails from "./styles";

const { NavTabsList, NavTabsItem } = NavTabs;
const WatchListBtn = WithMoviesWatchlistBtn(ButtonWatchlist);

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired,
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  movies: PropTypes.arrayOf(PropTypes.object).isRequired,
  cinemaDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.any]),
  savedLocation: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,

  fetchCinema: PropTypes.func.isRequired,
  fetchDates: PropTypes.func.isRequired,
  fetchMovieSessions: PropTypes.func.isRequired,
  fetchMovieOperaSessions: PropTypes.func.isRequired,
  setCinema: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  setMovieSessions: PropTypes.func.isRequired,
  content: PropTypes.object,
  fetchContent: PropTypes.func.isRequired,
  gastronomyContent: PropTypes.object,
  fetchContentGastronomy: PropTypes.func.isRequired,
  fetchExtraInfo: PropTypes.func.isRequired,
  extraInfo: PropTypes.object,
  hallTicketDetails: PropTypes.arrayOf(PropTypes.object),
  getHallTicketdetails: PropTypes.func.isRequired,
  setLoaderData: PropTypes.func.isRequired
};

const defaultProps = {
  cinemaDetails: null
};

const compare = (a, b) => {
  if (new Date(a.showtime) < new Date(b.showtime)) {
    return -1;
  }
  if (new Date(a.showtime) > new Date(b.showtime)) {
    return 1;
  }

  return 0;
};

const CinemaDetails = ({
  match,
  dates,
  movies,
  cinemaDetails,
  savedLocation,
  isLoggedIn,
  locations,
  fetchCinema,
  fetchDates,
  fetchMovieSessions,
  fetchMovieOperaSessions,
  setCinema,
  setDates,
  setMovieSessions,
  content,
  setContent,
  fetchContent,
  fetchExtraInfo,
  extraInfo,
  hallTicketDetails,
  getHallTicketdetails,
  fetchContentGastronomy,
  gastronomyContent,
  setLoaderData,
  legalInfo
}) => {
  const { id: cinemaName } = match.params;
  const {
    location: { state }
  } = useRouter();

  const selectedCinema = useSelector(state => state.cinemas.cinemas);
  // const selectedId = selectedCinema?.find(item => item.name?.replaceAll(' ', '-') === cinemaName);
  const selectedId = selectedCinema?.find(
    item => item.cinemaUrlName === cinemaName
  );
  const idRef = useRef(state?.cinemaId);
  const [t, i18n] = useTranslation();
  const mapRef = useRef(null);
  const {
    name,
    address1,
    address2,
    phoneNumber,
    geo,
    social,
    loyaltyCode,
    favorite,
    hint,
    gallery
  } = cinemaDetails || {};

  const address = `${address1}${address2 ? `, ${address2}` : ""}`;
  const [isMainTabVisible, toggleTabs] = useState(true);
  const { getDateWithOffset } = useUtils();
  const { googleMapKey, routes } = useConfig();
  const { country } = useConfig();

  const { date } = useUrlParams("date");
  const { isDateValid, isDateExist, onDateSelected } = useDateUrlReplace(dates);
  const [showMap, setShowMap] = useState(false);
  const { redLabelDate, onSelectDate } = useDateSelector(date, onDateSelected);
  const [data, setData] = useState([]);
  const [gastronomy, setGastronomy] = useState([]);
  const [cinemaExtraInfo, setCinemaExtraInfo] = useState([]);
  const [changeUrl, setChangeUrl] = useState("");
  const [sendUrl, setSendUrl] = useState({});
  const [gastronomySendUrl, setGastronomySendUrl] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [priceType, setPriceType] = useState("");
  useEffect(() => {
    setContent(null);

    return () => {
      setCinema(null);
      setDates(null);
      setMovieSessions(null);
    };
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_COUNTRY === "svn") {
      document.title = "Cineplexx | Kino";
    }

    return () => {
      document.title = "Cineplexx";
    };
  }, []);

  useEffect(() => {
    fetchExtraInfo();
  }, [cinemaDetails?.id]);

  useEffect(() => {
    if (!state?.cinemaId && !selectedId?.id) return;

    fetchCinema(state?.cinemaId || selectedId?.id);
    idRef.current = state?.cinemaId || selectedId?.id;
  }, [state?.cinemaId, selectedId?.id]);

  useEffect(() => {
    if (!idRef.current && !locations && !locations.length) return;

    // const params = { cinemaId: idRef.current };

    // if (savedLocation === 'all') {
    /* eslint-disable no-param-reassign */
    // const locationsScheme = locations.reduce((acc, l) => {
    //   for (let i = 0; i < l.items.length; i += 1) {
    //     acc[l.items[i]] = l.id.toString();
    //   }

    //   return acc;
    // }, {});
    // /* eslint-enable no-param-reassign */
    // params.location = locationsScheme[idRef.current];
    // }

    fetchDates({ cinemaId: idRef.current, location: "all" });
  }, [idRef.current]);

  useEffect(() => {
    if (
      (state?.cinemaId || selectedId?.id) &&
      date &&
      (date=="all" || ((isDateValid && !isDateExist) || (isDateValid && isDateExist)))
    ) {
      const id = state?.cinemaId || selectedId?.id;
      fetchMovieSessions(id, date);
    }
  }, [date, state?.cinemaId, selectedId?.id]);

  useEffect(() => {
    const technologyPriceList = 1;

    const params = { id: idRef?.current, technologyPriceList, type: "main" };

    fetchContent(params);
    setPriceType("main");
  }, [idRef?.current]);

  const languageContents = useMemo(
    () => ({
      topHeadline:
        i18n.language === "en" || i18n.language === "en-US"
          ? "topHeadlineEN"
          : "topHeadline"
    }),
    [i18n.language]
  );

  useEffect(() => {
    if (data?.technologyPriceList) {
      setChangeUrl(data?.[languageContents.topHeadline]);
    } else {
      setChangeUrl(cinemaName);
    }

    const to = {
      pathname: generatePath(routes.priceList.pattern, {
        slug: cinemaName || changeUrl
      }),
      state: { cinemaName, priceId: data?.id }
    };

    setSendUrl(to);
  }, [data?.technologyPriceList, content]);

  useEffect(() => {
    if (cinemaDetails?.linkedPricelist !== undefined) {
      if (gastronomy?.technologyPriceList) {
        setChangeUrl(gastronomy?.[languageContents.topHeadline]);
      } else {
        setChangeUrl(cinemaName);
      }
      if (gastronomy?.id !== undefined) {
        const to = {
          pathname: generatePath(routes.gastorPriceList.pattern, {
            slug: cinemaName || changeUrl
          }),
          search: `?gastronomy=${gastronomy?.id}`,
          state: { cinemaName, priceId: gastronomy?.id, isGastronomy: true }
        };

        setGastronomySendUrl(to);
      }
    }
  }, [gastronomy, gastronomyContent]);

  useEffect(() => {
    // if (content && content?.data && content?.data.length > 0) {
    //   setData(content?.data?.[0]);
    // }
    setData(content?.data?.[0] ?? null);
  }, [content]);

  useEffect(() => {
    if (gastronomyContent && gastronomyContent?.data?.length > 0) {
      setGastronomy(gastronomyContent?.data?.[0]);
    }
  }, [gastronomyContent]);

  useEffect(() => {
    if (extraInfo?.length > 0) {
      extraInfo.forEach(element => {
        if (element?.cinemaId === cinemaDetails?.id) {
          setCinemaExtraInfo(element);
        }

        return null;
      });
    }
  }, [extraInfo]);

  useEffect(() => {
    const id_ = cinemaDetails?.linkedPricelist;

    if (id_ !== undefined) {
      const technologyPriceList = 1;
      const params = { id: Number(id_), technologyPriceList, type: "sub" };

      fetchContentGastronomy(params);
    }
    setPriceType("sub");
  }, [cinemaDetails]);

  // useEffect(() => {
  //   setLoaderData(true)
  //   const timer = setTimeout(() => {
  //     setLoaderData(false)
  //   }, 4000);
  // },[])
  const [windowSize, setWindowSize] = useState();

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, [window]);
  window.addEventListener(
    "resize",
    function() {
      setWindowSize(window.innerWidth);
    },
    true
  );

  return (
    cinemaDetails && (
      <SectionCinemaDetails>
        <Container>
          <MainEntityDetails isVisible={isMainTabVisible || true}>
            <div className="fixed-cinema-detail">
              <Container>
                <div className="cinema-details__date">
                  <MoviesDatesFilter
                    dates={dates.length ? dates : date === "all" ? [] : [date]}
                    selectedDate={date}
                    onSelectDate={onSelectDate}
                    redLabelDate={redLabelDate}
                    withPadding={false}
                    isAsAllDates
                    withAllDateOption
                  />
                </div>
                <header
                  className={`s-cinema-details__header${
                    isLoggedIn ? " _logged" : ""
                  }`}
                >
                  <div className="s-cinema-details__header-inner">
                    <Fragment>
                      <h1 className="s-cinema-details__title">
                        {isLoggedIn ? (
                          <FavoriteBtn
                            id={cinemaDetails.id}
                            loyaltyCode={loyaltyCode}
                            favorite={favorite}
                          />
                        ) : null}
                        <span className="s-cinema-details__title-text">
                          {name}
                        </span>
                      </h1>
                    </Fragment>
                  </div>
                </header>
              </Container>
            </div>
            <div>
              <div
                className={
                  windowSize <= 992 && gallery && gallery.length
                    ? "cinema-list-details"
                    : "cinema-nogallery-details"
                }
              >
                {gallery && gallery.length ? (
                  <EntityGallery gallery={gallery} />
                ) : null}
                <CinemaInfo className="mt-0" message={hint} />
                <div className="s-cinema-details__nav-tabs">
                  <NavTabsList>
                    <NavTabsItem
                      isSelected={isMainTabVisible}
                      onClick={() => toggleTabs(true)}
                      text={t("movies.showtimes")}
                    />
                    <NavTabsItem
                      isSelected={!isMainTabVisible}
                      onClick={() => toggleTabs(false)}
                      text={t("common.details")}
                    />
                  </NavTabsList>
                </div>
              </div>
              <>
                {movies?.length ? (
                  <Fragment>
                    {isMainTabVisible && (
                      <>
                        <SessionState />
                        <SessionsList>
                          {movies.map(movie => (
                            <SessionsListItem key={movie.id} as="li">
                              <TitleWithPoster
                                date={date}
                                entityDetails={movie}
                                location={savedLocation}
                                cinemaId={cinemaDetails.id}
                              >
                                {isLoggedIn ? (
                                  <WatchListBtn
                                    id={movie.id}
                                    isInWatchList={movie.isInWatchlist}
                                    isDetails
                                  />
                                ) : null}
                              </TitleWithPoster>
                              <TicketsList
                                tickets={sessionsReducer(
                                  movie?.sessions?.sort(compare),
                                  getDateWithOffset
                                )}
                              />
                            </SessionsListItem>
                          ))}
                        </SessionsList>
                      </>
                    )}
                  </Fragment>
                ) : (
                  <NoContent
                    svgId="no-movies"
                    text={t("movies.no_movies_details")}
                  />
                )}
              </>

              {showMap && (
                <CinemaMap
                  geo={geo}
                  name={name}
                  address={address}
                  mapRef={mapRef}
                  apiKey={googleMapKey}
                />
              )}
            </div>
          </MainEntityDetails>

          <Aside
            cinemaDetails={cinemaDetails}
            isVisible={!isMainTabVisible}
            social={social}
            sendUrl={sendUrl}
            gastronomySendUrl={gastronomySendUrl}
            country={country}
            cinemaExtraInfo={cinemaExtraInfo}
            phoneNumber={phoneNumber}
            address={address}
            mapRef={mapRef}
            setShowMap={setShowMap}
            legalInfo={legalInfo}
          />
        </Container>
      </SectionCinemaDetails>
    )
  );
};

CinemaDetails.propTypes = propTypes;
CinemaDetails.defaultProps = defaultProps;
export default CinemaDetails;
